import { Avatar, Button, Image, Space, Table, Tooltip } from "antd";
import { boxOptions, ingredientOptions } from "constants/index";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { formatCurrency } from "utils/index";
import ModalDelete from "../ModalDelete";

export default function TableBox({
  loading,
  dataSource,
  onOpenModalUpdate,
  onOpenModalDelete,
  fetchBox,
  openNotificationWithIcon
}) {
  const { t } = useTranslation()

  const columns = [
    {
      title: t('image'),
      dataIndex: "imageUrl",
      key: "imageUrl",
      render: (_) => <Image width={60} src={_} preview={false} />
    },
    {
      title: t('name'),
      dataIndex: "name",
      key: "name",
    },
    {
      title: t('type'),
      dataIndex: "type",
      key: "type",
      render: (_) => t(boxOptions[_ - 1].label),
    },
    {
      title: t('vegetarian'),
      dataIndex: "isVegetarian",
      key: "isVegetarian",
      render: (_) => _ ? 'O' : 'X',
    },
    {
      title: t('ingredient'),
      dataIndex: "ingredients",
      key: "ingredients",
      render: (_) => (
        <div>
          {_.map(row => (
            <div>{row.ingredient.name}: {row.quantity}</div>
          ))}
        </div>
      ),
    },
    {
      title: t('price'),
      dataIndex: "price",
      key: "price",
      render: (_) => formatCurrency(_),
    },
    {
      title: t('quantitySalmon'),
      dataIndex: "numSalmon",
      key: "numSalmon",
      render: (_, row) => row.ingredients.reduce((cur, next) => cur + (next?.ingredient?.numSalmon || 0) * next?.quantity, 0),
    },
    {
      title: t('quantityTuna'),
      dataIndex: "numTuna",
      key: "numTuna",
      render: (_, row) => row.ingredients.reduce((cur, next) => cur + (next?.ingredient?.numTuna || 0) * next?.quantity, 0),
    },
    {
      title: t('action'),
      dataIndex: "action",
      key: "aciton",
      render: (text, row) => {
        return (
          <Space key={row._id}>
            <Tooltip title={t('edit')}>
              <Button
                title={t('edit')}
                onClick={() => onOpenModalUpdate(row)}
              >
                <EditOutlined />
              </Button>
            </Tooltip>
            <ModalDelete
              row={row}
              onSearch={fetchBox}
              openNotificationWithIcon={openNotificationWithIcon}
            />
          </Space>
        );
      },
    },
  ]

  return (
    <Table loading={loading} columns={columns} dataSource={dataSource} bordered />
  );
}
